import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  tour: {
    progress: 0,
    isLoading: true,
    lang_code: "",
    id: "",
    language_id: "",
    name: "",
    slug: "",
    imageUrl: "",
    position_nb: "",
    tourSteps: [],
  },
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    setTour: (state, action) => {
      state.tour = action.payload;
    },
    setLoading: (state, action) => {
      state.tour.isLoading = action.payload;
    },
    updateProgress: (state, action) => {
      state.tour.progress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTour.pending, (state, action) => {
      state.tour.progress = 0;
      state.tour.isLoading = true;
    });
    builder.addCase(fetchTour.fulfilled, (state, action) => {
      const { tour, tourSteps } = action.payload;
      state.tour = tour;
      state.tour.tourSteps = tourSteps;
      state.tour.isLoading = false;
      state.tour.progress = 100;
    });
  },
});

export const fetchTour = createAsyncThunk(
  "tour/fetchTour",
  async (language_code, { dispatch }) => {
    dispatch(updateProgress(10));
    const url =
      process.env.REACT_APP_NODE_ENV === "production"
        ? process.env.REACT_APP_PROD_API_URL
        : process.env.REACT_APP_DEV_API_URL;

    const response = await fetch(`${url}/api/${language_code}/getTour`);

    const data = await response.json();

    dispatch(updateProgress(30));

    const { tourSteps } = data;

    const audioUrls = tourSteps.map((tourStep) => tourStep.audioUrl);
    const imageUrls = tourSteps.map((tourStep) => tourStep.imageUrl);

    // join audioUrls and imageUrls arrays
    const allMedia = audioUrls.concat(imageUrls);

    dispatch(updateProgress(50));

    // cache tour media
    if ("serviceWorker" in navigator && "caches" in window) {
      const CACHE_NAME = "v1"; // process.env.REACT_APP_CACHE_NAME
      const cache = await caches.open(CACHE_NAME);

      for (let i = 0; i < allMedia.length; i++) {
        await cache.add(allMedia[i]);
        const progress = ((i + 1) / allMedia.length) * 50 + 50;
        dispatch(tourSlice.actions.updateProgress(progress));
      }
    }

    return data;
  }
);

export const { setTour, setLoading, updateProgress } = tourSlice.actions;
export default tourSlice.reducer;
